export default "__VITE_ASSET__5409bbf0__"